import { Chip, Table } from '@heroui/react'

import { RowActions } from '@/components/ui/row-actions'
import { translated } from '@/lib/api/common'

import { ChoiceType } from '../types'
import type { ChoiceGroup } from '../types'

export type ChoiceGroupRowAction = 'edit' | 'moveUp' | 'moveDown' | 'delete'

interface ChoiceGroupsTableProps {
  groups: ChoiceGroup[]
  onAction: (action: ChoiceGroupRowAction, group: ChoiceGroup) => void
  busyIds: string[]
  isReordering: boolean
}

export function ChoiceGroupsTable({
  groups,
  onAction,
  busyIds,
  isReordering,
}: ChoiceGroupsTableProps) {
  return (
    <Table>
      <Table.ScrollContainer>
        <Table.Content aria-label="Choice groups">
          <Table.Header>
            <Table.Column id="name" isRowHeader>
              Group
            </Table.Column>
            <Table.Column id="selection">Selection</Table.Column>
            <Table.Column id="required">Required</Table.Column>
            <Table.Column id="actions">
              <span className="sr-only">Actions</span>
            </Table.Column>
          </Table.Header>

          <Table.Body>
            {groups.map((group, index) => (
              <Table.Row key={group.id} id={group.id}>
                <Table.Cell>
                  <span className="font-medium">{translated(group.name)}</span>
                </Table.Cell>

                <Table.Cell>
                  <span className="text-muted text-sm">
                    {group.selectType === ChoiceType.Multiple ? 'Pick several' : 'Pick one'}
                  </span>
                </Table.Cell>

                <Table.Cell>
                  <Chip size="sm" variant="soft" color={group.isRequire ? 'warning' : 'default'}>
                    {group.isRequire ? 'Required' : 'Optional'}
                  </Chip>
                </Table.Cell>

                <Table.Cell>
                  <RowActions
                    label={translated(group.name)}
                    isBusy={busyIds.includes(group.id) || isReordering}
                    onAction={(id) => onAction(id as ChoiceGroupRowAction, group)}
                    actions={[
                      { id: 'edit', label: 'Edit' },
                      ...(index > 0 ? [{ id: 'moveUp', label: 'Move up' }] : []),
                      ...(index < groups.length - 1
                        ? [{ id: 'moveDown', label: 'Move down' }]
                        : []),
                      { id: 'delete', label: 'Delete' },
                    ]}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Content>
      </Table.ScrollContainer>
    </Table>
  )
}
